import { Column } from 'further-ui/components/Layout';
import Table, { type Column as TableColumn } from 'further-ui/components/Table';
import { numberToCurrencyString } from 'further-ui/utils';
import { CommitmentData } from '../../types';

type Props = Pick<CommitmentData, 'currencySettings' | 'closeHistory'>;

const FundCloseHistory: React.FC<Props> = ({
  currencySettings,
  closeHistory,
}) => {
  const { currencyLcy } = currencySettings;
  const { data, totals } = closeHistory;

  const columns: Array<TableColumn<(typeof data)[number]>> = [
    {
      label: 'Close name',
      key: 'name',
      render: ({ name }) => name,
      footer: 'Total',
    },
    {
      label: 'Date',
      key: 'date',
      render: ({ date }) => date.toReadable(),
    },
    {
      label: 'New commitment',
      key: 'newCommitmentLcy',
      render: ({ newCommitmentLcy }) =>
        numberToCurrencyString(newCommitmentLcy, { currency: currencyLcy }),
      footer: numberToCurrencyString(totals.commitmentValueLcy, {
        currency: currencyLcy,
      }),
    },
    {
      label: 'Net equalisation interest paid/(received)',
      key: 'netEqualisationInterestPaidLcy',
      render: ({ netEqualisationInterestPaidLcy }) =>
        numberToCurrencyString(netEqualisationInterestPaidLcy, {
          currency: currencyLcy,
        }),
      footer: numberToCurrencyString(totals.netEqualisationInterestLcy, {
        currency: currencyLcy,
      }),
    },
  ];

  return (
    <Column>
      <Table emptyMessage="No entries" columns={columns} rows={data} />
    </Column>
  );
};

export default FundCloseHistory;
